var FrequencyTypes;
(function (FrequencyTypes) {
    FrequencyTypes["FORTYFOURA"] = "44a";
    FrequencyTypes["FIFTYSIXA"] = "56a";
})(FrequencyTypes || (FrequencyTypes = {}));
export default FrequencyTypes;
